//@ts-ignore
import { CPF } from 'cpf_cnpj';
import { idadeParaEmancipar, maiorDeIdade } from '../../helpers/verificadorDeData';
import { manterSomenteNumeros } from '../../helpers/mascaras';

export const MENSAGEM_CONFIRMACAO = 'Confira o CPF e data de nascimento e tente novamente.';
export const MENSAGEM_SITUACAO_DESCONHECIDA = 'Não foi encontrado uma situação para o CPF.';
export const MENSAGEM_SITUACAO_NAO_PERMITE = 'A situação do CPF informado não permite seu cadastro em uma inscrição.';
export const MENSAGEM_INSTABILIDADE = 'Sua inscrição não pode ser criada. Tente do novo em alguns minutos.';
export const TITULO_CONFIRMACAO = 'Não foi possível confirmar seus dados';
export const TITULO_INSTABILIDADE = 'Instabilidade sistemica';

export interface ContextoDaConsulta {
  edicao: boolean;
  consultarNome: boolean;
  acessoAdministrativo: boolean;
}

export interface DecisaoDeConsulta {
  consultar: boolean;
  cpf?: string;
  data?: string;
  erroData?: string;
  idadeInsuficiente?: boolean;
}

const dataIso = (dataDeNascimento: string) =>
  `${dataDeNascimento.slice(4, 8)}-${dataDeNascimento.slice(2, 4)}-${dataDeNascimento.slice(0, 2)}`;

export const caminhoInformacoesDoPretendente = (cpf: string, dataDeNascimento: string) =>
  `/pretendentes/${cpf}/${dataIso(dataDeNascimento)}/informacoesDoPretendente`;

const cpfPronto = (cpf?: string) => {
  const numeros = manterSomenteNumeros(cpf || '');
  return numeros.length === 11 && CPF.isValid(numeros) ? numeros : undefined;
};

export const avaliarConsultaDoNome = (
  contexto: ContextoDaConsulta,
  cpf?: string,
  data?: string
): DecisaoDeConsulta => {
  if (contexto.edicao || !contexto.consultarNome)
    return { consultar: false };

  const cpfValido = cpfPronto(cpf);
  if (!cpfValido)
    return { consultar: false };

  const erroData = contexto.acessoAdministrativo
    ? idadeParaEmancipar(data as never)
    : maiorDeIdade(data as never);

  if (erroData)
    return {
      consultar: false,
      erroData,
      idadeInsuficiente: erroData.startsWith('É necessário'),
    };

  return {
    consultar: true,
    cpf: cpfValido,
    data: manterSomenteNumeros(data || ''),
  };
};

export const deveBloquearAoAlterarIdentificacao = (contexto: ContextoDaConsulta) =>
  !contexto.edicao && contexto.consultarNome && !contexto.acessoAdministrativo;

export type TipoDeFalhaDaConsulta = 'confirmacao' | 'instabilidade';

export const classificarFalhaDaConsulta = (mensagem?: string, semResposta?: boolean): TipoDeFalhaDaConsulta => {
  if (semResposta || mensagem === MENSAGEM_INSTABILIDADE)
    return 'instabilidade';
  return 'confirmacao';
};

export const avisoDaFalha = (mensagem?: string, semResposta?: boolean) => {
  const tipo = classificarFalhaDaConsulta(mensagem, semResposta);
  if (tipo === 'instabilidade')
    return {
      tipo: 'atencao' as const,
      titulo: TITULO_INSTABILIDADE,
      texto: mensagem || MENSAGEM_INSTABILIDADE,
    };

  return {
    tipo: 'erro' as const,
    titulo: mensagem === MENSAGEM_CONFIRMACAO || !mensagem ? TITULO_CONFIRMACAO : 'Identificamos um erro:',
    texto: mensagem || MENSAGEM_CONFIRMACAO,
  };
};

export const efeitoDaFalha = (acessoAdministrativo: boolean, tipo: TipoDeFalhaDaConsulta) => {
  if (acessoAdministrativo)
    return { permiteCadastro: true, limparNome: true };

  if (tipo === 'instabilidade')
    return { permiteCadastro: false, limparNome: false };

  return { permiteCadastro: false, limparNome: true };
};

interface ErroDaConsulta {
  response?: {
    status?: number;
    data?: { mensagens?: string[] };
  };
}

export const falhaDaConsulta = (error: unknown, acessoAdministrativo: boolean) => {
  const erro = error as ErroDaConsulta | undefined;
  const status = erro?.response?.status;
  const semResposta = !erro?.response;
  const mensagem = erro?.response?.data?.mensagens?.join('\n');
  const autorizacao = status === 401 || status === 403;

  return {
    aviso: autorizacao ? undefined : avisoDaFalha(mensagem, semResposta),
    efeito: efeitoDaFalha(
      acessoAdministrativo,
      autorizacao ? 'confirmacao' : classificarFalhaDaConsulta(mensagem, semResposta)
    ),
  };
};
